export default "__VITE_ASSET__DOdMAAFI__"